import { MemberFilterData, MemberSortData } from '../../../shared/dto/EntityRepository';
import { ExposureLevel, PerPage } from '../../../shared/enum/EnumRepository';

export function buildMemberListParams(
  metaData: { page: number; size: PerPage; sortData: MemberSortData },
  filter: Partial<MemberFilterData> = {}
): URLSearchParams {
  const p = new URLSearchParams();

  p.set('page', String(metaData.page));
  p.set('size', String(metaData.size));
  p.set('sortBy', metaData.sortData.sort);
  p.set('direction', metaData.sortData.direction);

  // subscription: selected statuses only
  if (filter.subscription) {
    Object.entries(filter.subscription)
      .filter(([, on]) => on)
      .forEach(([status]) => p.append('subscriptionStatus', status));
  }

  // exposure: 전부 선택이면 파라미터 생략(필터 없음), 일부만 선택 시 exposureLevel 반복
  if (filter.isPublic) {
    const levels = Object.values(ExposureLevel);
    const allOn = levels.every((level) => filter.isPublic![level]);
    if (!allOn) {
      levels.forEach((level) => {
        if (filter.isPublic![level]) {
          p.append('exposureLevel', level);
        }
      });
    }
  }

  // lastLoginAt range (YYYY-MM-DD)
  if (filter.lastLoginAt) {
    if (filter.lastLoginAt.min != null) p.set('lastLoginAtMin', filter.lastLoginAt.min);
    if (filter.lastLoginAt.max != null) p.set('lastLoginAtMax', filter.lastLoginAt.max);
  }

  return p;
}
